import { View, Text } from "react-native";
import React, { useEffect } from "react";
import ExperienceCard from "./ExperienceCard";
import { styles } from "../styles/styles";

export default function UserExperiences({
  currentProfile,
  handleLikePress,
  interest,
  chatProfile,
  imageHeight,
  fromHomeFeed
}: {
  currentProfile: any;
  handleLikePress?: any;
  interest: any;
  chatProfile?: boolean;
  imageHeight?: any;
  fromHomeFeed?: boolean;
}) {
  const [interestedExperiences, setInterestedExperiences] = React.useState<
    any[]
  >([]);

  useEffect(() => {
    if (currentProfile?.interestedExperiences) {
      setInterestedExperiences(currentProfile?.interestedExperiences);
    }
  }, [currentProfile?.interestedExperiences]);

  //   console.log("interestedExperiences", interestedExperiences);

  return (
    <View style={styles.Experiences}>
      {interestedExperiences &&
        interestedExperiences?.map((experience: any, index: any) => {
          return (
            <View key={index}>
              <ExperienceCard
                image={experience?.media?.images.url}
                id={experience?.id}
                label="interested in"
                value={experience?.name}
                handleLikePress={handleLikePress}
                interest={interest}
                chatProfile={chatProfile}
                imageHeight={imageHeight}
                fromHomeFeed={fromHomeFeed}
              />
            </View>
          );
        })}
    </View>
  );
}
